import React, { useState } from 'react';
import { toast } from 'sonner';
import { Check, Loader2 } from 'lucide-react';
import { notesApi } from '@/lib/notesApi';
import { extractError } from '@/lib/errors';
import { PORTAL_MODE } from './useTagPortal';

// Optional reference no. (approval challan no. / sale bill no.). Editable only by the creator or the
// super admin (and never in Sales & Approval mode); everyone else sees it read-only.
export function TagRefNoField({ label, value, url, canEdit: canEditIn, onSaved, testid }) {
  const canEdit = canEditIn && !PORTAL_MODE.partial;
  const [v, setV] = useState(value || '');
  const [busy, setBusy] = useState(false);
  const dirty = v.trim() !== (value || '');
  if (!canEdit) return value ? <span className="inline-flex h-7 shrink-0 items-center rounded-lg border border-border bg-secondary/60 px-2 text-xs" data-testid={testid}>{label}: <b className="ml-1 font-mono">{value}</b></span> : null;
  const save = async () => {
    if (!dirty) return;
    setBusy(true);
    try { await notesApi.patch(url, { value: v.trim() }); toast.success(v.trim() ? `${label} saved.` : `${label} cleared.`); onSaved?.(); } catch (e) { toast.error(extractError(e, `Could not save the ${label.toLowerCase()}`)); } finally { setBusy(false); }
  };
  return (
    <span className="inline-flex h-7 shrink-0 items-center gap-1 rounded-lg border border-border bg-background pl-2 text-xs" onClick={(e) => e.stopPropagation()} data-testid={testid}>
      <span className="text-muted-foreground">{label}</span>
      <input value={v} onChange={(e) => setV(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') save(); }} maxLength={60} placeholder="optional" className="h-6 w-24 bg-transparent font-mono outline-none" data-testid={`${testid}-input`} />
      {dirty ? <button type="button" onClick={save} disabled={busy} className="grid h-7 w-7 place-items-center rounded-r-lg bg-emerald-600 text-white" aria-label={`Save ${label}`} data-testid={`${testid}-save`}>{busy ? <Loader2 size={12} className="animate-spin" /> : <Check size={13} />}</button> : null}
    </span>
  );
}
